module.exports = __webpack_public_path__ + "static/media/gallery7.cd2a0d5c.jpg";